import { render, staticRenderFns } from "./xhs_note_comments.vue?vue&type=template&id=57fa7352"
import script from "./xhs_note_comments.vue?vue&type=script&lang=js"
export * from "./xhs_note_comments.vue?vue&type=script&lang=js"
import style0 from "./xhs_note_comments.vue?vue&type=style&index=0&id=57fa7352&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports